import { render, staticRenderFns } from "./RightsTabContainer.vue?vue&type=template&id=77cb9518&"
import script from "./RightsTabContainer.vue?vue&type=script&lang=ts&"
export * from "./RightsTabContainer.vue?vue&type=script&lang=ts&"
import style0 from "./RightsTabContainer.vue?vue&type=style&index=0&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports